import React from "react";
import Mp from "ol/Map";
import View from "ol/View";
import * as source from 'ol/source';
import * as control from 'ol/control';
import * as layer from 'ol/layer';
import Feature from 'ol/Feature';
import * as geom from 'ol/geom';
import * as style from 'ol/style';
import pointType from "../enums/pointType";
import drawState from '../enums/drawState';
import "../mapComponent/map.css";
import 'ol/ol.css';
import { DEFAULT_RADIUS} from 'ol/sphere';
import * as olProj from 'ol/proj';

const upperZIndex = 100;
const lowerZIndex = 99;

class ResultMap extends React.Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.overlayRef = React.createRef();
    this.wayPoints = props.wayPoints;
    this.trajectoryPoints = this.transfromTrajectoryPoints(props.trajectoryPoints);
    this.loaded = props.loaded;
    this.wheelDistance = props.wheelDistance;
    this.polygons = props.polygons;
    this.areaPolygon = props.areaPolygon;
    this.linesBetweenPoints = props.linesBetweenPoints;
    this.map = undefined;
    this.sourceLine = undefined;
    this.vectorLine = undefined;
    this.sourceLineToChosenPoint = undefined;
    this.vectorLineToChosenPoint = undefined;
    this.displaySource = undefined;
    this.displayLineSource = undefined;
    this.displayVectorLayer = undefined;
    this.movementLayer = undefined;
    this.polygonSource = undefined;
    this.polygonVectorLayer = undefined;
    this.vectorSource = undefined;
    this.animationSource = undefined;
    this.props = props;
    this.inAnimation = false;
    this.pause = false;
    this.animationStep = 3;
    this.clickPointCallback = this.clickPointCallback.bind(this);
    this.setAnimationSpeed = this.setAnimationSpeed.bind(this);
    this.animationDelay = 2;
    this.animationDelayEveryNTh = 1;
  }

  clickPointCallback(actualTrajectoryPointNo) {
    this.draw_movement_route_to_point(actualTrajectoryPointNo);
  }

  transfromTrajectoryPoints(points) {
    let transformedPoints = { points:[]};
    if (!Array.isArray(this.wayPoints) || this.wayPoints.length === 0 || !points || !Array.isArray(points.points))
      return;
    let startPoint = this.wayPoints[0];

    points.points.forEach(pointCoords => {
      let startPointTransformed = olProj.transform([startPoint.Lon, startPoint.Lat], 'EPSG:3857', 'EPSG:4326');
      let transformedCoords = this.transformPointToESPG3857Units(pointCoords[0], pointCoords[1], startPointTransformed);
      let transformedCircleCenter =  (pointCoords[3] || pointCoords[4]) ? this.transformPointToESPG3857Units(pointCoords[3], pointCoords[4], startPointTransformed) : [0,0];
      transformedPoints.points.push([...transformedCoords, pointCoords[2], transformedCircleCenter[0], transformedCircleCenter[1]])
    });

    return transformedPoints;
  }

  transformPointToESPG3857Units(relativeLon, relativeLat, startPoint) {
    let lat = startPoint[1] + this.toDegrees(Math.sin((relativeLat/DEFAULT_RADIUS)/2) * 2.0);
    let middleLatRadius =  Math.cos(this.toRadians(startPoint[1] + ((lat - startPoint[1])/2))) * DEFAULT_RADIUS;
    let lon = startPoint[0] + this.toDegrees(Math.sin((relativeLon/middleLatRadius)/2) * 2.0);

    return olProj.transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
  }

  toDegrees (angle) {
    return angle * (180 / Math.PI);
  }

  toRadians (angle) {
    return angle * (Math.PI/180);
  }
  
  pauseAnimation() {
    this.pause = true;
  }
  resumeAnimation() {
    this.pause = false;
  }

  redrawAnimation() {
    if (this.inAnimation) {
      this.skipAnimation = true;
    }
    else  {  
      this.draw_movement_animation();
      this.skipAnimation = true;
    }
    this.pause = false;
  }

  drawAnimation() {
    this.pause = false;
    if (!this.inAnimation) {    
      this.draw_movement_animation();
    }
    //pauza
    else if (this.pause) {
      this.pause = false;
    }
  }

  componentDidMount() {
    this.displaySource = new source.Vector();
    this.displayLineSource = new source.Vector();
    this.polygonSource = new source.Vector();

    let raster = new layer.Tile({
      source: new source.OSM()
    });

    this.vectorSource = new source.Vector({
      projection: 'EPSG:3857',
    });

    this.animationSource = new source.Vector({
      projection: 'EPSG:3857',
    });

    this.draw_inputs();
    
    this.displayVectorLayer = new layer.Vector({
      source: this.displaySource,
      style: this.displayStyleFunction.bind(this),
    });

    this.displayLineLayer = new layer.Vector({
      source: this.displayLineSource,
      style: this.displayLineStyleFunction.bind(this),
    });

    this.polygonVectorLayer = new layer.Vector({
      source: this.polygonSource,
    });

    this.map = new Mp({
      layers: [raster, this.displayVectorLayer, this.displayLineLayer, this.polygonVectorLayer],
      target: 'map',
      controls: control.defaults({ attribution: false, zoom : true, rotate: false }),
      renderer: 'webgl',
      view: new View({
        center: [2022044.5499328873, 6354139.831606114],
        projection: 'EPSG:3857',
        zoom: 19
      })
    });

    this.set_map_position();

    this.map.getView().setZoom(
      this.map.getView().getZoom() - 1,
    )

    if (!this.trajectoryPoints)
      return;

    this.draw_movement_route(this.trajectoryPoints.points, this.wheelDistance);
  }

  set_map_position() {
    var polygons = this.polygonSource.getFeatures();
    if (polygons.length > 0) {
      let dataExtent = this.polygonSource.getExtent();
      if (dataExtent)
        this.map.getView().fit(dataExtent, this.map.getSize());
    }
    else {
      let dataExtent = this.displaySource.getExtent();
      if (dataExtent)
        this.map.getView().fit(dataExtent, this.map.getSize());
    }
  }

  draw_inputs() {
      if (this.areaPolygon)
        this.draw_input_polygon(this.areaPolygon[0]);

      if (this.wayPoints) {
        for (let wayPoint of this.wayPoints) {
          this.draw_input_point(wayPoint);
        }

        if (this.linesBetweenPoints)
          this.redrawLinesBetweenPonts();
      }

      if (this.polygons) {
        for (let polygon of this.polygons) {
          this.draw_input_polygon(polygon);
        }
      }
   }

   redrawLinesBetweenPonts() {
    this.displayLineSource.clear();
    let lastPoint;
    let allPoints = this.wayPoints;
    for (let point of allPoints) {
      if (!point || !lastPoint) {
        lastPoint = point;
        continue;
      }
      let points = [
        [lastPoint.Lon, lastPoint.Lat], [point.Lon, point.Lat]
      ];
      let feature = new Feature({
        geometry: new geom.LineString(points),
      });
      this.displayLineSource.addFeature(feature);
      
      lastPoint = point;
    }
  }

  displayStyleFunction(feature) {
    let styles = [];
    if (feature.values_.rotation !== undefined && feature.values_.rotation !== null) {
        styles.push(
            new style.Style({
                image: new style.Icon({
                    src: this.getIconByPointType(feature?.pointType),
                    rotateWithView: true,
                    rotation: -feature.values_.rotation
                }),
            })
        );
    }
    return styles;
  };

  displayLineStyleFunction(feature) {
    let styles = [];

        styles.push(
            new style.Style({
              stroke: new style.Stroke({
                color: [250, 166, 34, 255],
                width: 5,
                lineDash: [10],
                lineDashOffset: 30
              })
            })
        );
    return styles;
}

  draw_input_point(point) {
    if (!point)
      return;

    let rotation = Math.atan2(point.VectorY, point.VectorX);
    let feature = new Feature({
        geometry: new geom.Point([point.Lon, point.Lat]),
        rotation: rotation
    });
    feature.pointType = point.PointType;
    this.displaySource.addFeature(feature);
   }

   draw_input_polygon(polygon) {
    if (!polygon && polygon.length !== 1)
      return;

    let feature = new Feature({
        geometry: new geom.Polygon(polygon.coordinates)
    });
    this.set_polygon_style(feature, polygon);
    this.polygonSource.addFeature(feature);
   }

   set_polygon_style(feature, polygon) {
    if (polygon.drawStateContext === drawState.AREAPOLYGON) {
      //this.removeOldPolygon(this.state.drawState);
      feature.setStyle(
       new style.Style({
         stroke: new style.Stroke({
           color: [52, 168, 158, 255],
           width: 2,
         }),
         fill: new style.Fill({
           color: [190, 235, 214, 0.3]
         })
       }));
   }
   else {
     feature.setStyle(
       new style.Style({
         stroke: new style.Stroke({
           color: [86, 92, 94, 255],
           width: 2,
         }),
         fill: new style.Fill({
           color: [164, 163, 153, 0.3]
         })
       }));
   }
  }

  draw_arc(start_point, end_point, circle, turn_direction, line_style = null, return_points = false, source) {
    let translation = [circle[0], circle[1]]
    let start_recalc = [start_point[0] - translation[0], start_point[1] - translation[1]]
    let end_recalc = [end_point[0] - translation[0], end_point[1] - translation[1]]
    let arg_start_recalc = this.calculate_argument(start_recalc)
    let arg_end_recalc =  this.calculate_argument(end_recalc)
    let turning_angle =  this.calc_turning_angle(turn_direction, arg_start_recalc, arg_end_recalc)
    let radius =  this.calc_point_distance(circle, start_point)
    let nmb_of_dots =  this.get_count_of_arc_points(radius, turning_angle)
    let rot_angle_init = turning_angle / nmb_of_dots
    let points =  this.get_arc_points(nmb_of_dots, rot_angle_init, start_point, circle)
    if (return_points)
        return points
    if (points.length > 0) {
        let featureLine = new Feature({
            geometry: new geom.LineString(points)
        });
        if (line_style)
          featureLine.setStyle(line_style);
        source.addFeature(featureLine);
    }
  }
  
  draw_line(start_point, end_point, line_style, source) {
    let points = [
        [start_point[0], start_point[1]],
        [end_point[0], end_point[1]],
    ];
  
    let featureLine = new Feature({
        geometry: new geom.LineString(points)
    });
    featureLine.setStyle(line_style);
    source.addFeature(featureLine);      
  }

  // return angle from 0 to 2pi
  calculate_argument(point)  {
    let x = point[0]
    let y = point[1]
    if (x > 0 && y >= 0)
      return Math.atan(y/x)
    if (x === 0 && y >= 0)
      return Math.PI/2
    if (x < 0 && y > 0)
      return Math.PI - Math.atan(y/(-x))
    if (x < 0 && y === 0)
      return Math.PI
    if (x < 0 && y < 0)
      return Math.atan(y/x) + Math.PI
    if (x === 0 && y < 0)
      return Math.PI*1.5
    if (x > 0 && y < 0)
      return 2*Math.PI - Math.atan((-y)/x)
  }
  
  calc_point_distance(start, end) {
    return Math.sqrt(Math.pow(start[0] - end[0], 2) + Math.pow(start[1] - end[1], 2))
  }
  
  calc_turning_angle(turn_direction, arg_start_recalc, arg_end_recalc) {
    if (turn_direction === 0) // turn right
    {
        if (arg_start_recalc <= arg_end_recalc)
            return -(2 * Math.PI - (arg_end_recalc - arg_start_recalc))
        else
            return -(arg_start_recalc - arg_end_recalc)
    }
    else // turn left
    {
        if (arg_start_recalc <= arg_end_recalc)
            return arg_end_recalc - arg_start_recalc
        else
            return 2 * Math.PI - (arg_start_recalc - arg_end_recalc)
    }
  }

  skipPointIfDistanceToNextPointIsLessThan1cm(start_point, end_point) {
      return Math.sqrt((start_point[0] - end_point[0])**2 + (start_point[1] - end_point[1])**2) < 0.01;
  }

  clearTrajectory() { this.vectorSource.clear(); this.sourceLine.clear(); }

  draw_movement_route(movement_points, line_width) {
    let line_style = new style.Style({
      stroke: new style.Stroke({
          color: 'rgba(255, 199, 5, 0.9)',
          width: line_width
      }),
    })

    this.sourceLine = new source.Vector();
    this.vectorLine = new layer.Vector({
        source: this.sourceLine
    });

    this.draw_movement(movement_points, movement_points.length, line_style, this.sourceLine)
    this.map.addLayer(this.vectorLine);
  }

  draw_movement_route_to_point(toPointNo) {
    //this.tryClearAnimation();
    let firstCall = false;
    this.tryClearRouteToPoint();
    if (this.vectorLineToChosenPoint== null) {
      this.sourceLineToChosenPoint = new source.Vector();
      this.vectorLineToChosenPoint = new layer.Vector({
          source: this.sourceLineToChosenPoint
      });
      firstCall = true;
    }

    //todo line_width
    let line_to_chosen_point_style = new style.Style({
      stroke: new style.Stroke({
          color: 'rgba(255, 0, 0, 0.9)',
          width: this.wheelDistance
      }),
    })

    this.draw_movement(this.trajectoryPoints.points, toPointNo, line_to_chosen_point_style, this.sourceLineToChosenPoint);
    if (firstCall)
      this.map.addLayer(this.vectorLineToChosenPoint);

    this.vectorLineToChosenPoint.setZIndex(upperZIndex);
    if (this.movementLayer)
      this.movementLayer.setZIndex(lowerZIndex);
  }

  tryClearRouteToPoint() {
    if (this.vectorLineToChosenPoint != null) { 
      var features = this.vectorLineToChosenPoint.getSource().getFeatures();
      features.forEach((feature) => {
        this.vectorLineToChosenPoint.getSource().removeFeature(feature);
      });
    }
  }

  tryClearAnimation() {
    this.animationSource.clear();
  }
  
  draw_movement(movement_points, drawedPointsNo, style, source) {//style, points count, jaka hladina??
    for (let i = 0; i < drawedPointsNo - 1; i++) {
        let start_point = [movement_points[i][0], movement_points[i][1]]
        let end_point = [movement_points[i + 1][0], movement_points[i + 1][1]]
        if (this.skipPointIfDistanceToNextPointIsLessThan1cm(start_point, end_point))
            continue;
        if (movement_points[i][2] === -1) // go straight
          this.draw_line(start_point, end_point, style, source)
        else if (movement_points[i][2] === 0) // turn right
          this.draw_arc(start_point, end_point, [movement_points[i][3], movement_points[i][4]], movement_points[i][2], style, false, source)
        else // turn left
          this.draw_arc(start_point, end_point, [movement_points[i][3], movement_points[i][4]], movement_points[i][2], style, false, source)
    }
  }

  resetAnimation() {
    if (this.animationSource)
    {
      this.skipAnimation = true;
      this.animationSource.clear();
    }
  }

  setAnimationSpeed(speedString) {
    let speed = parseFloat(speedString)
    if (isNaN(speed))
      return;
     let speed025 =  Math.round(speed / 0.25) * 0.25;

      switch(speed025) {
        case 3:
          this.animationDelay = 0;
          this.animationDelayEveryNTh = 3;
          break;
        case 2.75:
          this.animationDelay = 1;
          this.animationDelayEveryNTh = 3;
            break;          
        case 2.5:
          this.animationDelay = 2;
          this.animationDelayEveryNTh = 3;
            break;
        case 2.25:
          this.animationDelay = 3;
          this.animationDelayEveryNTh = 2;
          break;                   
        case 2:
          this.animationDelay = 4;
          this.animationDelayEveryNTh = 2;
          break;
        case 1.75:
          this.animationDelay = 5;
          this.animationDelayEveryNTh = 2;
          break;          
        case 1.5:
          this.animationDelay = 4;
          this.animationDelayEveryNTh = 1;
          break;
        case 1.25:
          this.animationDelay = 6;
          this.animationDelayEveryNTh = 1;
          break;                  
        case 1:
          this.animationDelay = 12;
          this.animationDelayEveryNTh = 1;
          break;
        case 0.75:
          this.animationDelay = 20;
          this.animationDelayEveryNTh = 1;
          break;          
        case 0.5:
          this.animationDelay = 30;
          this.animationDelayEveryNTh = 1;
          break;
        case 0.25:
          this.animationDelay = 90;
          this.animationDelayEveryNTh = 1;
          break;                  
        default:
          this.animationDelay = 0;
          this.animationDelayEveryNTh = 1;
      } 
    }     

  async draw_movement_animation() {
    this.tryClearRouteToPoint();
    this.inAnimation = true;

    if (this.animationSource)
      this.animationSource.clear();
    let movement_points = this.trajectoryPoints.points; 
    let line_width = this.wheelDistance;
    let animationWasResumed = false;

    var line_style = new style.Style({
        stroke: new style.Stroke({
            color: 'rgba(119, 13, 255, 0.5)',
            width: line_width
        }),
    });

    this.movementLayer = new layer.Vector({
        source: this.animationSource,
    });

    this.movementLayer.setZIndex(upperZIndex);
    if (this.vectorLineToChosenPoint)
      this.vectorLineToChosenPoint.setZIndex(lowerZIndex);
    this.map.addLayer(this.movementLayer);

    for (let i = 0; i < movement_points.length; i++) {
        let actualAnimationstep = this.animationStep;
        let circleAnimationStep = this.animationStep/4;
        if  (this?.props?.actualPointCallback)
          this.props.actualPointCallback(i);
        //last point was alredy drawn  
        if (i === movement_points.length - 1) {
          this.inAnimation = false;
          return;
        }

        let start_point = [movement_points[i][0], movement_points[i][1]]
        let end_point = [movement_points[i + 1][0], movement_points[i + 1][1]]
        if (this.skipPointIfDistanceToNextPointIsLessThan1cm(start_point, end_point))
            continue;

        if (movement_points[i][2] === -1) //go straight
        {
            let vector = [movement_points[i + 1][0] - movement_points[i][0], movement_points[i + 1][1] - movement_points[i][1]]
            let vector_norm = Math.sqrt(Math.pow(vector[0], 2) + Math.pow(vector[1], 2))
            vector[0] /= vector_norm;
            vector[1] /= vector_norm;
            let actual_point = [movement_points[i][0], movement_points[i][1]];
            for (let j = 0; j < Math.floor(this.calc_point_distance(movement_points[i], movement_points[i + 1]) / actualAnimationstep); j++) {
              if (this.skipAnimation) {
                this.resetAnimation();
                this.skipAnimation = false;
                this.inAnimation = false;
                return;
              }

              while (this.pause) {
                // code block to be executed
                await this.resolveAfterMs(1000);
                if (this.skipAnimation) {
                  this.resetAnimation();
                  this.skipAnimation = false;
                  this.inAnimation = false;
                  return;
                }
                if (!animationWasResumed)
                  animationWasResumed = true;
              }
              //bod
              if (animationWasResumed) {
                animationWasResumed = false;
                this.tryClearRouteToPoint();
                this.movementLayer.setZIndex(upperZIndex);
                //smazat caru            
              }
              //speedup animation with lowering delay frequency
              if (j % this.animationDelayEveryNTh === 0)
                await this.delay(this.animationDelay);
              let nextPoint = [actual_point[0] + vector[0] * actualAnimationstep, actual_point[1] + vector[1] * actualAnimationstep];
              let points = [
                  [actual_point[0], actual_point[1]],
                  nextPoint
              ];
              actual_point =nextPoint
              let featureLine = new Feature({
                  geometry: new geom.LineString(points)
              });
              featureLine.setStyle(line_style);
              this.animationSource.addFeature(featureLine);
            }
            if (this.calc_point_distance(movement_points[i], movement_points[i + 1]) % actualAnimationstep !== 0) // do the rest of the last step
            {
                let calculatedStep = this.calc_point_distance(movement_points[i], movement_points[i + 1]) % actualAnimationstep;

                await this.delay(this.AnimationDelay);         
                let points = [
                    [actual_point[0], actual_point[1]],
                    [actual_point[0] + vector[0] * calculatedStep, actual_point[1] + vector[1] * calculatedStep],
                ];
                let featureLine = new Feature({
                    geometry: new geom.LineString(points)
                });
                featureLine.setStyle(line_style);
                this.animationSource.addFeature(featureLine);
            }
        }
        else // turn left or right
        {
            let translation = [movement_points[i][3], movement_points[i][4]]
            let start_recalc = [start_point[0] - translation[0], start_point[1] - translation[1]]
            let end_recalc = [end_point[0] - translation[0], end_point[1] - translation[1]]
            let arg_start_recalc = this.calculate_argument(start_recalc)
            let arg_end_recalc = this.calculate_argument(end_recalc)
            let turning_angle = this.calc_turning_angle(movement_points[i][2], arg_start_recalc, arg_end_recalc)
            let radius_of_circle = this.calc_point_distance(translation, start_point);
            let angle_step =0;
            if (movement_points[i][2] === 0)
                angle_step = -1 * circleAnimationStep / radius_of_circle
            else
                angle_step = circleAnimationStep / radius_of_circle
            if ((angle_step < 2 * Math.PI) && (angle_step < Math.abs(turning_angle))) {
                let actual_point_recalc = start_recalc
                let rot_matrix = [[Math.cos(angle_step), -Math.sin(angle_step)], [Math.sin(angle_step), Math.cos(angle_step)]]
                for (let j = 0; j < Math.floor(Math.abs(turning_angle) / Math.abs(angle_step)); j++) {
                    if (this.skipAnimation) {
                      this.resetAnimation();
                      this.inAnimation = false;
                      this.skipAnimation = false;
                      return;
                    }
                    //speedup animation with lowering delay frequency
                    if (j % this.animationDelayEveryNTh/2 === 0)
                      await this.delay(this.AnimationDelay);

                    let points = [
                        [actual_point_recalc[0] + translation[0], actual_point_recalc[1] + translation[1]],
                        [rot_matrix[0][0] * actual_point_recalc[0] + rot_matrix[0][1] * actual_point_recalc[1] + translation[0], rot_matrix[1][0] * actual_point_recalc[0] + rot_matrix[1][1] * actual_point_recalc[1] + translation[1]],
                    ];
                    actual_point_recalc = [rot_matrix[0][0] * actual_point_recalc[0] + rot_matrix[0][1] * actual_point_recalc[1], rot_matrix[1][0] * actual_point_recalc[0] + rot_matrix[1][1] * actual_point_recalc[1]]
                    //never used actual_point = [actual_point_recalc[0] + translation[0], actual_point_recalc[1] + translation[1]]
                    let featureLine = new Feature({
                        geometry: new geom.LineString(points)
                    });
                    featureLine.setStyle(line_style);
                    this.animationSource.addFeature(featureLine);
                }
                if (Math.abs(turning_angle) % Math.abs(angle_step) !== 0) // do rest of the last step
                {
                    angle_step = Math.abs(turning_angle) % Math.abs(angle_step)
                    if (movement_points[i][2] === 0)
                        angle_step = -angle_step
                    let rot_matrix = [[Math.cos(angle_step), -Math.sin(angle_step)], [Math.sin(angle_step), Math.cos(angle_step)]]
                    let points = [
                        [actual_point_recalc[0] + translation[0], actual_point_recalc[1] + translation[1]],
                        [rot_matrix[0][0] * actual_point_recalc[0] + rot_matrix[0][1] * actual_point_recalc[1] + translation[0], rot_matrix[1][0] * actual_point_recalc[0] + rot_matrix[1][1] * actual_point_recalc[1] + translation[1]],
                    ];
                    let featureLine = new Feature({
                        geometry: new geom.LineString(points)
                    });
                    featureLine.setStyle(line_style);
                    this.animationSource.addFeature(featureLine);
                }
            }
        }
    }
    this.inAnimation = false;
  }

  resolveAfterMs(ms) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, ms);
    });
  }

  delay = ms => new Promise(res => setTimeout(setTimeout(res, ms), 0));
  
  get_arc_points(nmb_of_dots, rot_angle_init, start_point, circle) {
    let translation = [circle[0], circle[1]]
    let start_recalc = [start_point[0] - translation[0], start_point[1] - translation[1]]
    let points = [];
    for (let i = 0; i <= nmb_of_dots; i++) // draw arc
    {
        let rot_angle = i * rot_angle_init
        let rot_matrix = [[Math.cos(rot_angle), -Math.sin(rot_angle)], [Math.sin(rot_angle), Math.cos(rot_angle)]]
        let point = [rot_matrix[0][0] * start_recalc[0] + rot_matrix[0][1] * start_recalc[1], rot_matrix[1][0] * start_recalc[0] + rot_matrix[1][1] * start_recalc[1]]
        point = [point[0] + translation[0], point[1] + translation[1]]
        points.push(point);
    }
    return points
  }
  
  get_count_of_arc_points(radius, angle) {
    let percentage_step = 0.01
    let length_of_arc = (2 * Math.PI * radius * angle) / (2 * Math.PI)
    let step = percentage_step * length_of_arc
    let count_of_points = Math.round(length_of_arc / step) + 1
    return count_of_points
  }

  render() {
    return (
      <>
        <div ref={this.mapRef} id="map" style={{ width: '100%', height: '100%' }}></div>
        <div ref={this.overlayRef}>Overlay</div>
      </>
    );
  }

  getIconByPointType(myPointType) {
    if (!myPointType)
        return '/arrow.png';

    switch(myPointType) {
      case pointType.START: {
        return '/start-oriented.png';
      }
      case pointType.END: {
        return '/end-oriented.png';
      }
      case pointType.UNORIENTED | pointType.TRANSIT: {
        return '/point.png';
      }
      case pointType.TRANSIT: {
        return '/point-oriented.png';
      }
      default:
        return '/point-oriented.png';  
    }
  }
}

export default ResultMap;



























